import { createSvgIcon } from 'shared/icons/IconUtils';

export const DriveawayIcon = createSvgIcon(
  'Driveaway',
  <path
    fill="currentColor"
    d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 1.913c3.677 0 6.787 2.468 7.765 5.834-2.743-.706-5.294-1.051-7.765-1.051-2.47 0-5.022.344-7.765 1.05C5.213 6.382 8.323 3.914 12 3.914zm0 10.609a2 2 0 110-4 2 2 0 010 4zm-7.933-.955c3.283.036 5.846 2.695 5.846 6.085l-.003.16a8.112 8.112 0 01-5.843-6.245zm10.023 6.245a4.464 4.464 0 01-.003-.16c0-3.39 2.562-6.05 5.846-6.085a8.112 8.112 0 01-5.843 6.245z"
  />,
);
